import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-housekeeping',
  templateUrl: './housekeeping.component.html',
  styleUrls: ['./housekeeping.component.scss']
})
export class HousekeepingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
